package com.gloopgo.game.moderation

import kotlinx.browser.localStorage

actual fun createBlockedPlayersStore(): BlockedPlayersStore {
    val key = "gloopgo.blocked_players"
    return PersistedBlockedPlayersStore(
        load = { localStorage.getItem(key).orEmpty() },
        save = { value -> localStorage.setItem(key, value) }
    )
}
